import ServiceBase from './ServiceBase';

export default class BlogPostsService extends ServiceBase {
    getBlogPosts(pageIndex = 0) {
        const searchParams = {
            pageIndex,
        };

        return this.request('get', 'blog/getblogposts', {
            params: searchParams,
        });
    }
}